__turbopack_context__.v({
  "eyebrow": "DevopsServicesCardSection-module__WySqUG__eyebrow",
  "heading": "DevopsServicesCardSection-module__WySqUG__heading",
  "section": "DevopsServicesCardSection-module__WySqUG__section",
  "title": "DevopsServicesCardSection-module__WySqUG__title",
});
